// Set contract addresses
// const GAME_STAKING_ADDRESS = "0x04Bc92167844B1362563d371a29022C84BeFb4a2";
export const GAME_TOKEN_ADDRESS = "0x825459139C897D769339f295E962396C4F9E4A4D";
export const GAME_STAKING_ADDRESS =
  "0x8F5a383Cf7f3A8195970e57dE81Af2133a84512F";
